import React from 'react';
import { NotesInput } from 'app/components';
import { useEmployerCreateNotesMutation, useEmployerUpdateNotesMutation } from 'app/hooks';
import type { EmployerDetail, EmployerDetailNote } from 'app/types';

type EmployerNotesProps = {
  note: EmployerDetailNote | null;
  onRefetch: () => void;
  isLoading: boolean;
  employer?: Pick<EmployerDetail, 'employerId' | 'owner'>;
};

export const EmployerNotes = ({ note, onRefetch, isLoading, employer }: EmployerNotesProps) => {
  const { mutate: createNotesMutation, isLoading: isCreating } = useEmployerCreateNotesMutation();
  const { mutate: updateNotesMutation, isLoading: isUpdating } = useEmployerUpdateNotesMutation();

  const loading = isLoading || isCreating || isUpdating;

  const onSaveNote = React.useCallback(
    (noteText: string) => {
      if (!employer?.owner?.ownerId || !employer?.employerId) {
        return;
      }

      const onSuccess = () => onRefetch();

      const commonData = {
        ownerId: employer.owner.ownerId,
        employerId: employer.employerId,
        noteText,
      };

      if (note?.noteId) {
        updateNotesMutation(
          {
            ...commonData,
            noteId: note.noteId,
          },
          { onSuccess },
        );
      } else {
        createNotesMutation(commonData, { onSuccess });
      }
    },
    [createNotesMutation, employer, note, onRefetch, updateNotesMutation],
  );

  return <NotesInput isLoading={loading} inputValue={note?.text || ''} onSaveNote={onSaveNote} />;
};
